import React, { useEffect, useState } from 'react';
import { CheckCircle, AlertCircle, CreditCard } from 'lucide-react';
interface ProcessingAnimationProps {
  onComplete: () => void;
  status: 'processing' | 'success' | 'error';
}
export function ProcessingAnimation({
  onComplete,
  status
}: ProcessingAnimationProps) {
  const [message, setMessage] = useState('Connecting to your bank...');
  useEffect(() => {
    if (status === 'processing') {
      const timer1 = setTimeout(() => setMessage('Verifying OTP...'), 3000);
      const timer2 = setTimeout(() => setMessage('Processing payment...'), 3000);
      const timer3 = setTimeout(() => setMessage('Finalizing transaction...'), 4500);
      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
        clearTimeout(timer3);
      };
    } else if (status === 'success') {
      setMessage('Payment Successful!');
      const timer = setTimeout(() => onComplete(), 5000);
      return () => clearTimeout(timer);
    } else if (status === 'error') {
      setMessage('Payment Failed');
    }
  }, [status, onComplete]);
  return <div className="flex flex-col items-center justify-center py-12 text-center" data-id="element-540">
      {status === 'processing' && <div className="relative mb-8" data-id="element-541">
          <div className="w-24 h-24 border-4 border-blue-100 rounded-full" data-id="element-542"></div>
          <div className="w-24 h-24 border-4 border-blue-600 rounded-full border-t-transparent animate-spin absolute top-0 left-0" data-id="element-543"></div>
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-544">
            <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center animate-pulse" data-id="element-545">
              <CreditCard className="w-8 h-8 text-blue-600" data-id="element-546" />
            </div>
          </div>
        </div>}

      {status === 'success' && <div className="mb-8 transform scale-100 transition-transform duration-500 ease-out" data-id="element-547">
          <CheckCircle className="w-24 h-24 text-green-500" data-id="element-548" />
        </div>}

      {status === 'error' && <div className="mb-8" data-id="element-549">
          <AlertCircle className="w-24 h-24 text-red-500" data-id="element-550" />
        </div>}

      <h2 className={`text-2xl font-bold mb-2 ${status === 'success' ? 'text-green-600' : status === 'error' ? 'text-red-600' : 'text-gray-900'}`} data-id="element-551">
        {status === 'success' ? 'Transaction Approved' : status === 'error' ? 'Transaction Declined' : 'Processing Payment'}
      </h2>

      <p className="text-gray-600 animate-pulse" data-id="element-552">{message}</p>

      {status === 'processing' && <p className="text-sm text-gray-500 mt-8 max-w-xs" data-id="element-553">
          Please do not close this window or press the back button.
        </p>}
    </div>;
}